<template>
  <div :class="['loading-container', direction]">
    <v-progress-circular
      indeterminate
      :color="color"
      :size="size"
      :width="width"
      class="loading-spinner"
    ></v-progress-circular>
    <span v-if="showText" class="loading-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    size: {
      type: [String, Number],
      default: 24
    },
    width: {
      type: [String, Number],
      default: 3
    },
    text: {
      type: String,
      default: 'Loading...'
    },
    showText: {
      type: Boolean,
      default: true
    },
    direction: {
      type: String,
      default: 'row',
      validator: (value) => ['row', 'column'].includes(value)
    }
  }
};
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 12px;
  padding: 24px;
  color: #2f4051;
  font-size: 14px;
  font-weight: 500;

  &.column {
    flex-direction: column;
  }

  &.row {
    flex-direction: row;
  }
}

.loading-spinner {
  flex-shrink: 0;
}

.loading-text {
  flex-shrink: 0;
  color: #2f4051;
  font-size: 14px;
  font-weight: 500;
}
</style>
